module.exports = __webpack_public_path__ + "img/icon-underwriting.4776ec15.svg";